import './clear-filters-button.scss'
import React from "react";
import { cleatFilterIcon } from "cui/assets/images/icons";
import SvgIcon from "cui/utils/SvgIcon";
import { Button, DataGrid } from "devextreme-react";

export const ClearFiltersButton = ({ gridRef }: { gridRef: React.RefObject<DataGrid<any, any>> }) => {
  return (
    <Button
      onClick={() => gridRef.current?.instance.clearFilter('header')} className="button-clear-filters"
    >
      <SvgIcon className="cleatFilterIcon" svg={cleatFilterIcon} />
      <span className="button-text">Clear</span>
    </Button>
  )
}
